<template>
    <div class="banIn">
        <div class="inImg">
            <img :src="banImg" alt="">
        </div>
        <div class="inText flex-center color_f">
            <div class="wrap">
                <slot name="text"></slot>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['url'],
        name: 'Header',
        data() {
            return {
                banImg: ''
            }

        },
        mounted() {
            this.getBan();
        },
        methods: {
            getBan() {
                let data = JSON.parse(localStorage.getItem('banner'));
                let img = this.url
                this.banImg = data[img]
            }
        }
    }
</script>
<style lang="scss" scoped>
    .banIn{
        position: relative;
        height: 520px;
        max-height: 32vw;
        .inImg{
            height: 100%;
            img{
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .inText{
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            .inTit{
                line-height: 1.2;
                font-weight: normal;
                margin: .1rem 0;
            }
            .inDes{
                max-width: 1000px;
                line-height: 1.6;
                margin: .1rem 0;
            }
        }
    }
    @media (max-width:767px) {
        .banIn{
            max-height: 3rem;
            .inText{
                .inDes{
                    line-height: 24px;
                    max-height: 48px;
                    overflow: hidden;;
                }
            }
        }
    }
</style>